import { IMAGE_SERVER } from "../../../../common/constants/systemUrls";

export const adjustExecutorById = data => {
  const { companyIdExec: company } = data;
  // console.log(data);
  let newData = {
    companyId: company.companyId,
    nameLegal: company.nameLegal,
    createdAtDate: company.createdAt,
    addressLegal: company.addressLegal,
    inn: company.inn,
    kpp: company.kpp,
    ogrn: company.ogrn,
    addressFact: company.addressFact,
    phone: company.phone,
    phoneCode: company.phoneCode,
    email: company.email,
    site: company.site,
    companyPhoto: company.picture
  };

  if (data.bankAccount) {
    newData["bankAccount"] = data.bankAccount.map((item, index) => index);
    data.bankAccount.forEach((item, index) => {
      newData["accountCorr" + index] = item.accountCorr;
      newData["bankName" + index] = item.bankName;
      newData["bik" + index] = item.bik;
      newData["bankAccountNum" + index] = item.bankAccountNum;
      newData["bankAccountId" + index] = item.bankAccountId;
    });
  }

  newData.name = company.nameLegal;

  return newData;
};

export const adjustExecutor = data => {
  let newData = {
    companyId: data.companyId,
    nameLegal: data.nameLegal ? data.nameLegal : undefined,
    createdAtDate: data.createdAt ? data.createdAt : undefined,
    addressLegal: data.addressLegal ? data.addressLegal : undefined,
    inn: data.inn ? data.inn : undefined,
    kpp: data.kpp ? data.kpp : undefined,
    ogrn: data.ogrn ? data.ogrn : undefined,
    addressFact: data.addressFact ? data.addressFact : undefined,
    phone: data.phone ? data.phone : undefined,
    phoneCode: data.phoneCode ? data.phoneCode : "+7",
    email: data.email ? data.email : undefined,
    site: data.site ? data.site : undefined,
    companyPhoto: data.picture ? IMAGE_SERVER + data.picture : undefined,
    birthPlace: data.birthPlace ? data.birthPlace : undefined,
    lastname: data.lastname ? data.lastname : undefined,
    name: data.name ? data.name : undefined,
    patronymic: data.patronymic ? data.patronymic : undefined,
    subjectId: data.subjectId,
    subjectKey:
      data.subjectId && data.subjectId === 4
        ? "legal"
        : data.subjectId === 6
        ? "individ"
        : "physical",
    subjectName:
      data.subjectId && data.subjectId === 4
        ? "Юридическое лицо"
        : data.subjectId === 6
        ? "Индивидуальный предприниматель"
        : "Физическое лицо",

    birthDate:
      data.birthDate && data.birthDate !== "0000-00-00"
        ? data.birthDate
        : undefined,
    archive: data.archive
  };

  newData.taxSystem = undefined;
  if (data.nds === 0) {
    newData.taxSystem = 0;
  }
  if (data.nds === 1) {
    newData.taxSystem = 1;
  }

  if (data.bankAccount) {
    newData["bankAccount"] = data.bankAccount.map((item, index) => index);
    data.bankAccount.forEach((item, index) => {
      newData["accountCorr" + index] = item.accountCorr;
      newData["bankName" + index] = item.bankName;
      newData["bik" + index] = item.bik;
      newData["bankAccountNum" + index] = item.bankAccountNum;
      newData["bankAccountId" + index] = item.bankAccountId;
    });
  }

  if (newData.subjectKey === "physical") {
    let name = [];
    if (data.lastname) name.push(data.lastname);
    if (data.name) name.push(data.name);
    if (data.patronymic) name.push(data.patronymic);
    newData.companyName = name.length > 0 ? name.join(" ") : "—";
  } else {
    newData.companyName = data.nameLegal ? data.nameLegal : "—";
  }
  return newData;
};

export const adjustExecutorSend = (profileId, data) => {
  let newData = {};
  // todo перевести апи на key
  if (data.subjectKey) {
    if (data.subjectKey === "legal") newData.subject_id = 4;
    if (data.subjectKey === "physical") newData.subject_id = 5;
    if (data.subjectKey === "individ") newData.subject_id = 6;
  }
  if (data.nameLegal) {
    newData.name_legal = data.nameLegal;
  }
  if (data.addressLegal) {
    newData.address_legal = data.addressLegal;
  }
  if (data.inn) {
    newData.inn = data.inn;
  }
  if (data.kpp) {
    newData.kpp = data.kpp;
  }

  if (data.ogrn) {
    newData.ogrn = data.ogrn;
  }
  if (data.taxSystem === 0 || data.taxSystem === 1) {
    newData.nds = String(data.taxSystem);
  }

  if (data.email) {
    newData.email = data.email;
  }
  if (data.phone) {
    newData.phone = data.phone;
  }
  if (data.phoneCode) {
    newData.phone_code = data.phoneCode;
  }

  if (data.addressFact) {
    newData.address_fact = data.addressFact;
  }
  if (data.site) {
    newData.site = data.site;
  }

  if (data.birthPlace) {
    newData.birth_place = data.birthPlace;
  }
  if (data.lastname) {
    newData.lastname = data.lastname;
  }
  if (data.name) {
    newData.name = data.name;
  }
  if (data.patronymic) {
    newData.patronymic = data.patronymic;
  }
  if (data.birthDate) {
    newData.birth_date = data.birthDate.format("YYYY-MM-DD");
  }

  // Данные о банке
  if (data.bankAccount && data.bankAccount.length !== 0) {
    newData["bank_account"] = data.bankAccount.map(item => ({
      bank_name: data[`bankName${item}`],
      bik: data[`bik${item}`],
      account_corr: data[`accountCorr${item}`],
      bank_account_num: data[`bankAccountNum${item}`],
      bank_account_id: data[`bankAccountId${item}`]
    }));
  }

  newData.company_type_id = 2;

  return newData;
};
